import {log,logout} from "./type"
export const logi={type:log};
export const logo={type:logout}